import { render, staticRenderFns } from "./finished-content.vue?vue&type=template&id=a356b406&scoped=true"
import script from "./finished-content.vue?vue&type=script&lang=js"
export * from "./finished-content.vue?vue&type=script&lang=js"
import style0 from "./finished-content.vue?vue&type=style&index=0&id=a356b406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a356b406",
  null
  
)

export default component.exports